import React, {useState, useEffect} from 'react';
import CardComponent from '../../reuseableComponents/CardComponent/CardComponent';
import ContainerCard from '../../reuseableComponents/CardComponent/ContainerCard/ContainerCard';
import HeadingNDescription from '../../reuseableComponents/headingNDescription/headingNDescription';
import Notification from '../../reuseableComponents/Notification';
import {getProperties} from './apis/apis';
import LeftSection from './leftSection';
import "./AllHome.scss";
import {Drawer, Button} from 'antd';
import {getFeaturedPropertiesApi} from "../landingPage/apis/apis";
import {filterProperties} from "../Search/apis/apis";
import Loader from "../../reuseableComponents/Loader/Loader";

const AllHome = () => {
    const [state, setState] = useState({
        drawer: false,
        propertiesData: [],
        featuredProperties: [],
        loader:false
    })

    const propertiesFunc = async (query) => {
        setState(prevState => ({
            ...prevState,
            loader: true
        }));
        try {
            let allData = query || null;
            if (allData?.type === null) {
                delete allData.type;
            }
            const [result, featuredProperties] = await Promise.all([
                allData ? filterProperties(allData) : getProperties(),
                getFeaturedPropertiesApi()
            ]);

            if (result.success) {
                setState(prevState => ({
                    ...prevState,
                    propertiesData: result?.data,
                    featuredProperties: featuredProperties?.data?.data || [],
                    loader:false
                }));
            }
            else if(result?.data?.success) {
                setState(prevState => ({
                    ...prevState,
                    propertiesData: result?.data?.data,
                    featuredProperties: featuredProperties?.data?.data || [],
                    loader: false
                }));
            }
            else {
                Notification('error', "Error", result.message || "Failed to fetch properties.");
                setState(prevState => ({
                    ...prevState,
                    loader: false
                }));
            }
        } catch (err) {
            Notification('error', "Error", err.message || "An unexpected error occurred.");
            setState(prevState => ({
                ...prevState,
                loader: false
            }));
        }
    };

    useEffect(() => {
        propertiesFunc()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div className={"all-container"} style={{
        padding: window.innerWidth > 790 ? "2%" : 0,
        paddingTop: "4%"
    }}>
        <div className={"allHomeContainer"}>
            <div className={"leftInAllHomes"}>
                <LeftSection propertiesFunc={propertiesFunc}/>
            </div>
            {
                window.innerWidth <= 790 && <Button style={{
                    marginTop: 70,
                    width: "90%",
                    marginLeft: "5%",
                    marginBottom: 40
                }} type="primary" onClick={() => setState({
                    ...state,
                    drawer: true
                })}>
                    Select filters
                </Button>
            }
            <div className={"right"}>
                <div className={"main-featured"}>
                    <h3>Featured Ads</h3>
                    <div className={"content"}>
                        {
                            state.featuredProperties.length > 0 && state.featuredProperties.map(item => <CardComponent
                                data={item}/>
                            )
                        }
                    </div>
                </div>

                <div className={"main-featured"} style={{
                    background: "none",
                    marginTop: 30
                }}>
                    <h3>Filter Results</h3>
                    <div style={{
                        marginTop: 30
                    }}/>
                    {
                        state.loader ? <Loader/> :  <ContainerCard data={state.propertiesData}/>
                    }
                </div>
            </div>
        </div>

        <Drawer
            title="Filters"
            placement="bottom"
            onClose={() => setState({
                ...state,
                drawer: false
            })}
            open={state.drawer && window.innerWidth <= 790}
            height={"90%"}
        >
            <LeftSection/>
        </Drawer>
    </div>
}
export default AllHome
